// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComboRelatorios_UnidadeInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query de GET /so/combo_relatorios/unidade (NS 2026-0090, fatia 4).
 *
 * `franquia_id` precisa ser do usuario (Permissoes_model::verificaFranquiaPermitida).
 * `data_inicio` e `data_fim` sao date-only (YYYY-MM-DD, sem conversao de fuso)
 * e filtram a data de criacao da compra e do movimento.
 */
import { registerContract } from './validate'

export interface ComboRelatorios_UnidadeInput {
franquia_id: number
data_inicio: string
data_fim: string
}

registerContract('ComboRelatorios_UnidadeInput', {
  franquia_id: { type: 'number',  required: true },
  data_inicio: { type: 'string',  required: true },
  data_fim:    { type: 'string',  required: true },
})
